import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "@modules/app/app.module";
import { config } from "config/environment";

import { defineCustomElements } from "cookie-banner/dist/loader";
import { datadogRum } from "@datadog/browser-rum";
import { ENVS } from "./config/envs";
import packageJson from "../package.json";

const IS_ERROR_LOGGING_ENV = config.envName === ENVS.STAGING || config.envName === ENVS.PROD;

if (!config.debug) {
	console.info = () => {
		/* do nothing */
	};
	console.debug = () => {
		/* do nothing */
	};
	console.warn = () => {
		/* do nothing */
	};
}

if (config.envName !== ENVS.LOCAL) {
	enableProdMode();
}

if (IS_ERROR_LOGGING_ENV) {
	datadogRum.init({
		applicationId: "03c77570-08cf-4676-9713-4c1c83a97474",
		clientToken: "pubc72754a1d32b2b646113115a8b852018",
		site: "datadoghq.eu",
		service: packageJson.service,
		env: config.envName === ENVS.PROD ? "production" : config.envName,
		version: packageJson.version,
		sessionSampleRate: config.envName === ENVS.STAGING ? 100 : 50,
		traceSampleRate: config.envName === ENVS.STAGING ? 100 : 30,
		sessionReplaySampleRate: 0,
		trackUserInteractions: true,
		trackFrustrations: true,
		trackLongTasks: true,
		trackResources: true,
		allowedTracingUrls: [config.apiUrl],
		defaultPrivacyLevel: "mask",
		enableExperimentalFeatures: ["feature_flags"]
	});
}

platformBrowserDynamic().bootstrapModule(AppModule);

defineCustomElements(window);
